import React from 'react';
import { MIDAS_MODULES } from '../../models/EnumMidasModules';
import SearchCustomerComponent from '../../shared/SearchCustomerComponent/SearchCustomerComponent';

interface QuoteProps {
  value?: any
};

export const Quote: React.FC<QuoteProps> = () =>
  <SearchCustomerComponent parentComponent={MIDAS_MODULES.QUOTE} />;